import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#A09CA3]">
        <div className="text-sm tracking-widest uppercase animate-pulse" data-testid="auth-checking">
          Loading…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}
